/* @flow */
import React from 'react';
import { GoogleMap, withGoogleMap } from 'react-google-maps';
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer';

type Props = {
  children: React$Node,
  saveZoom: (zoom: number) => void,
  saveCoordinates: (coordinates: CoordinatesT) => void,
  coordinates: {
    center: CoordinatesT,
    zoom: number,
  },
};

class MapWithAMarkerClusterer extends React.PureComponent<Props> {
  mapRef = React.createRef();

  onZoomChanged = () => {
    const newCenter = this.mapRef.current?.getCenter();
    if (this.mapRef.current?.getZoom) {
      this.props.saveZoom(this.mapRef.current.getZoom());
    }
    if (newCenter) {
      this.props.saveCoordinates({
        lat: newCenter.lat(),
        lng: newCenter.lng(),
      });
    }
  };

  render() {
    const { zoom, center } = this.props.coordinates;
    const defaultZoom = Number.isInteger(zoom) ? zoom : 1;

    return (
      <GoogleMap
        defaultZoom={defaultZoom}
        defaultMapTypeId="satellite"
        defaultCenter={{
          lat: 39,
          lng: -95,
        }}
        center={center}
        options={{
          streetViewControl: false,
          mapTypeControl: true,
          mapTypeControlOptions: {
            mapTypeIds: ['satellite', 'hybrid'],
          },
        }}
        ref={this.mapRef}
        onZoomChanged={this.onZoomChanged}
      >
        <MarkerClusterer averageCenter enableRetinaIcons gridSize={60}>
          {this.props.children}
        </MarkerClusterer>
      </GoogleMap>
    );
  }
}

export default withGoogleMap(MapWithAMarkerClusterer);
